import React from "react";
import Marquee from "react-fast-marquee";
import "../styles/marqeen.css"; 

// BioSurge Icons/Logos (Inhe replace kar lena apne actual images se)
import logo1 from '../assets/images/slide1.png'
import logo2 from '../assets/images/slide2.png'
import logo3 from '../assets/images/slide3.png'

const sliderData1 = [
  {
    title: "Unleash Natural Energy",
    subTitle: "Ayurvedic Herbal Wellness Blend",
    link: "#",
    img: logo1
  },
  {
    title: "Consistent Stamina Support",
    subTitle: "Helps reduce fatigue and support active living",
    link: "#",
    img: logo2
  },
  {
    title: "Traditional Majun Formula",
    subTitle: "Time-tested recipe crafted for modern lifestyles",
    link: "#",
    img: logo3
  },
  {
    title: "20+ Herbal Ingredients",
    subTitle: "Ashwagandha, Safed Musli & Akarkara blend",
    link: "#",
    img: logo1
  },
  {
    title: "Confidence & Vitality",
    subTitle: "Supports strength, balance and daily wellness",
    link: "#",
    img: logo2
  },
  {
    title: "Pure Honey Base",
    subTitle: "Carefully prepared herbal blend with natural ingredients",
    link: "#",
    img: logo3
  },
  {
    title: "Strength & Endurance",
    subTitle: "Supports overall vitality and active lifestyle",
    link: "#",
    img: logo1
  },
  {
    title: "Quality You Can Trust",
    subTitle: "Carefully sourced ingredients with quality assurance",
    link: "#",
    img: logo2
  },
];
const Marqeen = () => {
  return (
    <div className="marquee-container-wrapper">
      <Marquee gradient={false} speed={60} pauseOnHover={true}>
        {sliderData1.map((item, idx) => (
          <a
            href={item.link}
            key={idx}
            className="marquee-card"
          >
            <img
              src={item.img}
              alt={item.title}
              className="marquee-card-img"
            />
            <div className="marquee-text-box">
               <span className="marquee-card-title">{item.title}</span>
               <span className="marquee-card-subtitle">{item.subTitle}</span>
            </div>
          </a>
        ))}
      </Marquee>
    </div>
  );
};

export default Marqeen;